module.exports = __webpack_public_path__ + "static/media/J.ccdeb34c.jpg";